/* eslint-disable react/no-array-index-key */

import type { HTMLAttributes } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { Spacing8, Spacing16 } from 'autogen/design-tokens/tokens';
import FindationButton from 'components/Findation/FindationButton';
import RevieveVirtualTryOnButton from 'components/product/RevieveVirtualTryOn/RevieveVirtualTryOnButton';
import VariantsSection from 'components/product/Variants/VariantSection/VariantsSection';
import type { VariantsProps } from './shared/types';

// #region Styles
const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: ${Spacing16};
`;

const DigitalToolsContainer = styled.div`
    display: flex;
    gap: ${Spacing16};
`;

// #endregion Styles

export default function Variants({
    variants,
    productId,
    externalProductId,
    name,
    makeupInfo,
    revieveVirtualTryOn,
    findationViewModel,
    ...restProps
}: VariantsProps & HTMLAttributes<HTMLDivElement>) {
    const hasVariants = !!variants && !!variants.sections[0]?.variants[0];
    const hasMultipleVariantSections = !!variants && variants.sections.length > 1;

    if (!hasVariants) return null;

    return (
        <Wrapper {...restProps}>
            {variants?.sections.map((section, index) => {
                return (
                    <VariantsSection
                        variantsSection={section}
                        hasMultipleVariantSections={hasMultipleVariantSections}
                        key={index}
                    />
                );
            })}
            <DigitalToolsContainer>
                {revieveVirtualTryOn.config && (
                    <RevieveVirtualTryOnButton config={revieveVirtualTryOn} variants={variants} />
                )}
                {makeupInfo.isFindation && (
                    <FindationButton productId={findationViewModel.productId} productName={name} />
                )}
            </DigitalToolsContainer>
        </Wrapper>
    );
}
